module.exports = __webpack_public_path__ + "media/assets/icons/logo-e4f5ef2b268e617162a713aa8a008a45.png";